module.exports = "https://static.wagwalking.com/_next/static/images/happy-dog-1-d2bb388f8f09a3e5ea47a24ae7a80133.svg";